import React from 'react';

export const PlusIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.99984 15.8332C9.76373 15.8332 9.56595 15.7532 9.4065 15.5932C9.2465 15.4337 9.1665 15.2359 9.1665 14.9998V10.8332H4.99984C4.76373 10.8332 4.56567 10.7532 4.40567 10.5932C4.24623 10.4337 4.1665 10.2359 4.1665 9.99984C4.1665 9.76373 4.24623 9.56567 4.40567 9.40567C4.56567 9.24623 4.76373 9.1665 4.99984 9.1665H9.1665V4.99984C9.1665 4.76373 9.2465 4.56567 9.4065 4.40567C9.56595 4.24623 9.76373 4.1665 9.99984 4.1665C10.2359 4.1665 10.434 4.24623 10.594 4.40567C10.7534 4.56567 10.8332 4.76373 10.8332 4.99984V9.1665H14.9998C15.2359 9.1665 15.4337 9.24623 15.5932 9.40567C15.7532 9.56567 15.8332 9.76373 15.8332 9.99984C15.8332 10.2359 15.7532 10.4337 15.5932 10.5932C15.4337 10.7532 15.2359 10.8332 14.9998 10.8332H10.8332V14.9998C10.8332 15.2359 10.7534 15.4337 10.594 15.5932C10.434 15.7532 10.2359 15.8332 9.99984 15.8332Z"
      fill="currentColor"
    />
  </svg>
);
